import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=08e8c356&scoped=true&"
import script from "./Store.vue?vue&type=script&lang=js&"
export * from "./Store.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=08e8c356&scoped=true&lang=css&"
import style1 from "./Store.vue?vue&type=style&index=1&id=08e8c356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8c356",
  null
  
)

export default component.exports